// extracted by mini-css-extract-plugin
export var productImage = "_o0-1";
export var viewLink = "_o0-2";
export var wishlistItem = "_o0-0";